module.exports = __webpack_public_path__ + "img/con_11.d6c450fc.svg";